import { Data, Effect } from 'effect'

type UTMCodes = Record<string, string>

class MalformedUTMCookie extends Data.TaggedError('MalformedUTMCookie')<{
  cause: unknown
}> {}

/**
 * Reads a cookie whose value is a URLSearchParams string. Malformed marketing
 * attribution is deliberately ignored rather than blocking account creation.
 */
export function readUTMCodesFromCookieHeader(
  cookieHeader: string,
  cookieName: string
): Effect.Effect<UTMCodes | undefined> {
  const prefix = `${cookieName}=`
  const encoded = cookieHeader
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length)

  if (!encoded) return Effect.succeed(undefined)

  return Effect.try({
    try: () => decodeURIComponent(encoded),
    catch: (cause) => new MalformedUTMCookie({ cause })
  }).pipe(
    Effect.map((raw) => {
      const codes = Object.fromEntries(new URLSearchParams(raw).entries()) as UTMCodes
      return Object.keys(codes).length == 0 ? undefined : codes
    }),
    Effect.catchTag('MalformedUTMCookie', () => Effect.succeed(undefined))
  )
}
